export const Info = ({ image }) => {
    return (
        <div>
            {image?._id}
        </div>
    )
}